import * as React from "react";
import { createRoot } from "react-dom/client";
import App from "./components/App";
import { FluentProvider, webLightTheme } from "@fluentui/react-components";
import { extraireNomFichier } from "../utils/fichier";

/* global document, Office, module, require, HTMLElement */

const title = "zLawyer for Word";

const providerStyle: React.CSSProperties = {
  height: "100%",
  minHeight: 0,
  minWidth: 0,
  display: "flex",
  flexDirection: "column",
};

const rootElement: HTMLElement | null = document.getElementById("container");
const root = rootElement ? createRoot(rootElement) : undefined;

/* Render application after Office initializes */
Office.onReady((info) => {
  if (info.host === Office.HostType.Word) {
    try {
      Office.context.document.getFilePropertiesAsync((asyncResult) => {
        if (asyncResult.status === Office.AsyncResultStatus.Succeeded) {
          const fileName = extraireNomFichier(asyncResult.value?.url ?? "");

          root.render(
              <FluentProvider theme={webLightTheme} style={providerStyle}>
                <App title={title} fileName={fileName} />
              </FluentProvider>
          );
        } else {
          console.error("Error: ", asyncResult.error.message);
        }
      });
    } catch (error) {
      console.error("Error getting file properties: ", error);
    }
  } else {
    root.render(
        <FluentProvider theme={webLightTheme} style={providerStyle}>
          <h1 style={{ fontSize: "1rem", overflowWrap: "anywhere", padding: "12px" }}>
            Le complément zLawyer est uniquement disponible pour les fichiers word.
          </h1>
        </FluentProvider>
    );
  }
});

if ((module as any).hot) {
  (module as any).hot.accept("./components/App", () => {
    const NextApp = require("./components/App").default;
    root?.render(NextApp);
  });
}
